import actions from './actions'
import {RequestService as req} from "../../services/requestService";
import { Constants } from "../../config/constants";
import {fetchUsers} from "../userManagement/users/actionCreator";

const { fetchCareersAction, fetchTalentPoolAction, fetchMessageAction, fetchCommentAction, fetchCareerPostsAction, fetchCareerPostAction, resetCareerPostFormAction } = actions;


export const fetchCareerPosts = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}careerPost`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCareerPostsAction(cb)))
    };
};


export const addCareerPost = (data, action) => {
    return async dispatch => {
        await req.postRequest({
            url: `${Constants.CAREER}careerPost`,
            auth: 'bearer',
            body: data
        }, async (cb) => {
            await dispatch(fetchCareerPosts({page: 1,  perPage: 35}));
            if (action) await action();
        })
    };
};

export const updateCareerPost = (data, action) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.CAREER}careerPost/${data._id}`,
            auth: 'bearer',
            body: data
        },  async (cb) => {
            await dispatch(fetchCareerPosts({page: 1,  perPage: 35}));
            if (action) await action();
        })
    };
};

export const resetCareerPostForm = () => dispatch => dispatch(resetCareerPostFormAction());

export const fetchCareerPost = (_id, action) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}careerPost/${_id}`,
            auth: 'bearer'
        }, async (cb) => {
            await dispatch(fetchCareerPostAction(cb));
            if (action) await action();
        })
    };
};

export const deleteCareerPost = (_id) => {
    return async dispatch => {
        await req.deleteRequest({
            url: `${Constants.CAREER}careerPost/${_id}`,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCareerPosts({page: 1,  perPage: 35})))
    };
};

export const fetchCareers = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}career`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCareersAction(cb)))
    };
};

export const fetchTalentPool = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}career/talent`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchTalentPoolAction(cb)))
    };
};


export const fetchMessage = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}message`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchMessageAction(cb)))
    };
};

export const fetchComment = (queries) => {
    return async dispatch => {
        await req.getRequest({
            url: `${Constants.CAREER}comment`,
            queries,
            auth: 'bearer'
        }, (cb) => dispatch(fetchCommentAction(cb)))
    };
};

export const commentStatusUpdate = (data, pageInfo) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.CAREER}comment/update`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (pageInfo) {
                dispatch(fetchComment(pageInfo));
            } else if (data.userInformation?.studentId) {
                dispatch(fetchComment({ studentId: data.userInformation.studentId }));
            }
        })
    };
};


export const procedureStatusUpdate = (data, pageInfo) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.CAREER}procedure/status/update`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (pageInfo) {
                dispatch(fetchComment(pageInfo));
            } else if (data.userInformation?.studentId) {
                dispatch(fetchComment({ studentId: data.userInformation.studentId }));
            }
        })
    };
};

// export const commentHeadUpdate = (data) => {
//     return async dispatch => {
//         await req.putRequest({
//             url: `${Constants.CAREER}comment/head/update`,
//             auth: 'bearer',
//             // Send the whole data object so the backend sees req.body.userInformation
//             body: data,
//         }, async (cb) => {
//             if (data.userInformation.studentId) {
//                 dispatch(fetchComment({ studentId: data.userInformation.studentId }));
//             }
//         });
//     };
// };

export const commentHeadUpdate = (data, pageInfo) => {
    return async dispatch => {
        // We wrap the request in a Promise to ensure 'await' works correctly
        return new Promise((resolve) => {
            req.putRequest({
                url: `${Constants.CAREER}comment/head/update`,
                auth: 'bearer',
                body: data,
            }, (cb) => {
                // 1. Handle internal dispatch logic
                if (cb && !cb.error) {
                    if (pageInfo) {
                        dispatch(fetchComment(pageInfo));
                    } else if (data.userInformation?.studentId) {
                        dispatch(fetchComment({ studentId: data.userInformation.studentId }));
                    }
                    resolve(cb);
                } else {
                    resolve(cb || { error: true }); // Failure: Resolve with error info
                }
            });
        });
    };
};

export const commentHeadSMSUpdate = (data, pageInfo) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.CAREER}comment/head/sms/update`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            if (pageInfo) {
                dispatch(fetchComment(pageInfo));
            } else if (data.userInformation?.studentId) {
                dispatch(fetchComment({ studentId: data.userInformation.studentId }));
            }
        })
    };
};

export const messageStatusUpdate = (data) => {
    return async dispatch => {
        await req.putRequest({
            url: `${Constants.CAREER}message/update`,
            auth: 'bearer',
            body: data.userInformation,
        },  async (cb) => {
            dispatch(fetchMessage(data.filterInformation))
        })
    };
};